import React from "react";
import { createRoot } from "react-dom/client";
import ContactFaqQueryIsland from "./ContactFaqQueryIsland";

const mountNode = document.getElementById("contact-faq-query-island");

if (mountNode) {
  const rawConfig = mountNode.getAttribute("data-config");

  if (rawConfig) {
    const config = JSON.parse(rawConfig);
    createRoot(mountNode).render(<ContactFaqQueryIsland config={config} />);
  }
}
